import router from "@/router/index";
import * as model from "@/model/prd/inventoryMgt/FormulaPlan";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.FormulaPlan(), newFilter)
    .withStates({
        idReport: 2,
        baseModuleUrl: process.env.VUE_APP_PRODUCTION_API_URL + "production-service/inventory",
    }) //TODO load at the application start

    .withActions({

        formulaPlanNew() {
            router.push('/prd/formulaPlan/add');

        },

        View(context, entity) {
            // router.push( '/prd/formulaPlanDetails' );  
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/formulaPlanDetails" + "/findByAllPlanCode/" + context.state.entity.planCode
            }, { root: true })
                .then(response => {

                    {
                        context.commit('formulaPlanDetails' + "/setRows", response, { root: true })                            ;
                    }
                });
        }
    })
    .buildStore()







